





















































import { Component, Vue } from "vue-property-decorator";
import { passwordApi } from "../services/password.api";
import { vueAuth } from "../services/auth";
import appSnackbarService from "../../../services/appSnackbar.service";
import { PASSWORD_POLICY_REGEX } from "../../../helpers/passwordPolicy";

@Component({})
export default class RequiredPasswordChange extends Vue {
  currentPassword = "";
  password1 = "";
  password2 = "";
  errorMessage = "";
  valid = false;
  loading = false;
  show1 = false;
  show2 = false;

  passwordRule(v: string) {
    if (!PASSWORD_POLICY_REGEX.test(v)) {
      return this.$t("CHANGE_PASSWORD_RULE");
    }
    return true;
  }

  submit() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      this.errorMessage = "";
      passwordApi
        .requiredPasswordChange(this.currentPassword, this.password2)
        .then(res => {
          vueAuth.setToken(res.data, "token");
          sessionStorage.removeItem("qlm-pwd-required");
          appSnackbarService.success(this.$t("REQUIRED_PASSWORD_SUCCESS") as string);
          this.$router.replace("/");
        })
        .catch(error => {
          const errs = error.response && error.response.data;
          if (Array.isArray(errs)) {
            this.errorMessage = errs.map((e: any) => e.description || e.code).join("<br>");
          } else {
            this.errorMessage = this.$t("CHANGE_PASSWORD_ERROR") as string;
          }
          this.loading = false;
        });
    }
  }
}
